module.exports = __webpack_public_path__ + "images/emoji/trumpet.b0f43d89f6029315f5f6.png";